// International yard and pound definitions, exact by definition.
const KM_IN_MILE = 1.609344
const METERS_IN_FOOT = 0.3048

export const convertMilesToKm = (miles: number): number => miles * KM_IN_MILE

export const convertKmToMiles = (km: number): number => km / KM_IN_MILE

export const convertMetersToFeet = (meters: number): number =>
  meters / METERS_IN_FOOT

export const convertSquareMetersToSquareFeet = (squareMeters: number): number =>
  squareMeters / METERS_IN_FOOT ** 2
